import { apiService } from './api'
import { EnrollmentsResponse } from '../types/enrollment'

export class EnrollmentService {
  // 個人の受講一覧取得
  async getMyEnrollments(params?: {
    status?: string
    page?: number
    limit?: number
  }): Promise<EnrollmentsResponse> {
    try {
      return await apiService.get<EnrollmentsResponse>('/enrollments/my', params)
    } catch (error) {
      console.warn('APIが利用できません。デモデータを返します。')
      return this.getDemoEnrollments(params)
    }
  }

  private getDemoEnrollments(params?: any): EnrollmentsResponse {
    const demoEnrollments = [
      {
        id: 'demo-enrollment-1',
        status: 'COMPLETED' as const,
        dueDate: new Date(Date.now() + 7 * 86400000).toISOString(),
        assignedAt: new Date(Date.now() - 10 * 86400000).toISOString(),
        isOverdue: false,
        test: {
          id: 'demo-test-1',
          title: 'ハラスメント防止ガイドライン',
          description: 'ハラスメント防止に関する基本的な理解を確認するテスト',
          passingScore: 80,
          timeLimit: 30,
          complianceRule: {
            title: 'ハラスメント防止基本方針',
            category: 'ハラスメント防止',
            description: 'ハラスメント防止に関する基本的な方針',
          },
        },
        latestResult: {
          id: 'demo-result-1',
          score: 92,
          passed: true,
          attempt: 1,
          completedAt: new Date(Date.now() - 2 * 86400000).toISOString(),
        },
      },
      {
        id: 'demo-enrollment-2',
        status: 'ASSIGNED' as const,
        dueDate: new Date(Date.now() + 14 * 86400000).toISOString(),
        assignedAt: new Date().toISOString(),
        isOverdue: false,
        test: {
          id: 'demo-test-2',
          title: '情報セキュリティ基礎',
          description: '情報セキュリティに関する基礎的な理解を確認するテスト',
          passingScore: 80,
          timeLimit: 45,
          complianceRule: {
            title: '情報セキュリティ管理規程',
            category: '情報セキュリティ',
            description: '情報セキュリティに関する管理規程',
          },
        },
        latestResult: null,
      },
    ]

    // ステータスフィルタリング
    let filteredEnrollments = demoEnrollments
    if (params?.status) {
      filteredEnrollments = filteredEnrollments.filter((e) => e.status === params.status)
    }

    return {
      enrollments: filteredEnrollments,
      pagination: {
        page: params?.page || 1,
        limit: params?.limit || 10,
        total: filteredEnrollments.length,
        pages: Math.ceil(filteredEnrollments.length / (params?.limit || 10)),
      },
    }
  }
}

export const enrollmentService = new EnrollmentService()
